module.exports = __webpack_public_path__ + "img/drt12.d0baf8ab.png";